import { useEffect, useState } from "react";
import API from "../../api";
import Performance from "../../components/performance/performance";
import ActionTypes from "../../store/actionTypes";
import { useCentralStore } from "../../store/appContext";
import { isEmpty } from "../../utils/functionUtils";
import StoreSelection from "./storeSelection";
import StoreSelectionSea from "./storeSelectionSea";
import WelcomeSection from "./welcomeSection";
import Header from "../../components/common/header/headerOps";
import HamburgerMenu from "../../components/navigation/hamburger";
import MapsContainer from "../MapsContainer/MapsContainer";
import Spinner, {
  SpinnerLoader,
} from "../../components/common/spinner/spinner";
import LandingPage from "../../components/landing/landingPage";
import resources from "../../components/common/resources.json";
import ReportMenu from "../transaction/reportMenu";
import SiteMapDashboard from "./sitemap";
import BillingData from "../Reconciliation/BillingData";
import BilligRevenue from "../Reconciliation/BillingRevenue";
import PrmMenu from "../transaction/prmMenu";
import InquiryMenu from "../inquiryPortal/inquiryMenu";
import CelcomBillingData from "../Reconciliation/CelcomBillingData";
import CelcomBilligRevenue from "../Reconciliation/CelcomBillingRevenue";

const Dashboard = () => {
  const [
    {
      clientData,
      userData,
      userDetails,
      selectedTab,
      programName,
      loadingPer,
      FavouriteList,
      projectData,
      projectName,
      selectedCategory,
      selectedClient,
      childSubmatricsData,
      submatricsDetailsData,
      SiteMap,
      projectDataCheck,
      mapSelected,
      mapsPage
    },
    dispatch,
  ] = useCentralStore();
  // const history = useNavigate();
  // const location = useLocation();

  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING, payload: action });
  };
  
  useEffect(() => {
    setLoading(true);
    if (isEmpty(clientData)) {
      // API[ActionTypes.GET_CLIENTS](dispatch);
      let payload = {
        // Username: userDetails && userDetails?.email?.split("@")?.[0],
        idToken: userData?.access_token,
      };
      API[ActionTypes.GET_ROLE_BASES_MATRICS](payload, userDetails && userDetails?.email?.split("@")?.[0])
        .then(({ data }) => {
          setLoading(false);
          if (data) {
            dispatch({
              type: ActionTypes.GET_ROLE_BASES_MATRICS_SUCCESS,
              payload: data,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ActionTypes.GET_ROLE_BASES_MATRICS_FAILURE,
            payload: err,
          });
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let payload = {
            level: resources.POST_LOGGER_ERROR,
            category: resources.POST_LOGGER_API,
            ApiName: resources.POST_LOGGER_APINAME,
            message: {
              error: err,
              info: {
                idToken: "",
              },
            },
          };
          API[ActionTypes.POST_LOGGER](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
        });
    }
  }, []);

  let allDashboardsArray = [];
  clientData
    ?.filter((v) => v?.ClientId == selectedClient)[0]
    ?.Channels?.map((v) =>
      v?.AllDashboards?.map((a) => allDashboardsArray.push(a))
    );
  let allDashboards = allDashboardsArray?.filter(
    (v, i, a) => a.findIndex((v2) => v2.Label === v.Label) === i
  );

  const goToHomePage = () => {
    let payload = {
      // Username: userDetails && userDetails?.email?.split("@")?.[0],
      idToken: userData?.access_token,
    };
    API[ActionTypes.GET_ROLE_BASES_MATRICS](payload, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
        setLoading(false);
        if (data) {
          dispatch({
            type: ActionTypes.GET_ROLE_BASES_MATRICS_SUCCESS,
            payload: data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ActionTypes.GET_ROLE_BASES_MATRICS_FAILURE,
          payload: err,
        });
        dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
        let payload = {
          level: resources.POST_LOGGER_ERROR,
          category: resources.POST_LOGGER_API,
          ApiName: resources.POST_LOGGER_APINAME,
          message: {
            error: err,
            info: {
              idToken: "",
            },
          },
        };
        API[ActionTypes.POST_LOGGER](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  };

  const [disableScroll, setDisableScroll] = useState(false);
  useEffect(() => {
    if (!isEmpty(childSubmatricsData) || !isEmpty(submatricsDetailsData))
      setDisableScroll(true);
    else setDisableScroll(false);
  }, [childSubmatricsData, submatricsDetailsData]);

  // useEffect(() => {
  //   history(location.href);
  //   window.onpopstate = function () {
  //     history("/login");
  //   };
  // },[]);
  return (
    <div className={`h-full w-full ${disableScroll ? "overflow-hidden" : ""}`}>
      {projectName === "PRM Ops Scorecard Summary" || projectName === "Inquiry Portal" ? 
        "":
        projectName === "Celcom Billing Data" ? 
        <>
          {!isEmpty(projectName) && (!resources.Celcom_Portal.includes(projectName)) && (
            <Header
              className=""
              userDetails={userDetails}
              FavouriteList={FavouriteList}
              resources={resources}
            />
          )}
        </> :
        <>{!isEmpty(projectName) && (!resources.M1_Portal.includes(projectName)) && (
          <Header
            className=""
            userDetails={userDetails}
            FavouriteList={FavouriteList}
            resources={resources}
          />
        )}</> 
      }
      {/* <WelcomeSection className="p-2" /> */}

      {isEmpty(projectName) && (
        <LandingPage
          ActionTypes={ActionTypes}
          dispatch={dispatch}
          resources={resources}
          selectedCategory={selectedCategory}
        />
        // <SiteMapDashboard/>
      )}

      {projectName === resources.BPM_PROJECT_NAME && (
        <>
          {(isEmpty(programName) && (selectedTab == "MAP" || mapsPage)) ? (
            <MapsContainer resources={resources} />
          ) : (mapSelected?.toLowerCase() === "australia" ?
            <>
              <StoreSelection
                className=""
                selectedTab={selectedTab}
                resources={resources}
                goToHomePage={() => goToHomePage()}
                allDashboards={allDashboards}
                programName={programName}
              />
              {!projectDataCheck && <Spinner />}
              {projectData && (
                <Performance className="px-4" resources={resources} />
              )}
              {/* <HamburgerMenu
              className="fixed bottom-0 right-0"
              clientData={clientData}
              userDetails={userDetails}
              resources={resources}
            /> */}
            </>
            :
            <>
              <StoreSelectionSea
                className=""
                selectedTab={selectedTab}
                resources={resources}
                goToHomePage={() => goToHomePage()}
                allDashboards={allDashboards}
              />
              {!projectDataCheck && <Spinner />}
              {projectData && (
                <Performance className="px-4" resources={resources} />
              )}

              {/* <HamburgerMenu
              className="fixed bottom-0 right-0"
              clientData={clientData}
              userDetails={userDetails}
              resources={resources}
            /> */}
            </>
          )}
        </>
      )}

      {projectName === "Sitemap" && <SiteMapDashboard/>}
      {projectName === resources.Billing_Data && <BillingData/>}
      {projectName === resources.Billing_Revenue && <BilligRevenue/>}
      {projectName === resources.Celcom_Billing_Data && <CelcomBillingData/>}
      {projectName === resources.Celcom_Billing_Revenue && <CelcomBilligRevenue/>}

      {/* {site} */}

      {projectName === resources.TRANSACTIONAL_REPORTING_PROJECT_NAME && (
        <ReportMenu />
      )}
      {projectName === 'PRM Ops Scorecard Summary' && (
        <PrmMenu />
      )}
      {projectName === 'Inquiry Portal' && (
        <InquiryMenu />
      )}

    </div>
  );
};

export default Dashboard;